// Plantillas pre-armadas + helpers de fórmula KPI (espejo de backend/kpi_evaluator.py)

export const KPI_TEMPLATES = [
  {
    key: "cumplimiento_meta_ventas",
    label: "% Cumplimiento de meta de ventas",
    description: "Mide qué porcentaje de la meta de ventas del período se logró.",
    formula_template: "(ventas_real / meta_mes) * 100",
    formula_human: "(Ventas reales ÷ Meta del período) × 100",
    output_unit: "percentage", output_decimals: 2,
    data_source: "Reporte de ventas del período (cierre Wansoft).",
    capture_example: "Si vendieron $15,000 y la meta era $12,000, captura Ventas reales=15000 y Meta=12000. El sistema calcula 125%.",
    input_fields: [
      { key: "ventas_real", label: "Ventas reales (MXN)", type: "currency", unit: "MXN", required: true, min: 0, max: null, help_text: "Total vendido en el período." },
      { key: "meta_mes", label: "Meta del período (MXN)", type: "currency", unit: "MXN", required: true, min: 0, max: null, help_text: "Meta asignada al período." },
    ],
  },
  {
    key: "merma_produccion",
    label: "% Merma sobre producción",
    description: "Porcentaje de producto descartado respecto al total producido.",
    formula_template: "(merma_kg / produccion_kg) * 100",
    formula_human: "(Mermas en kg ÷ Producción total en kg) × 100",
    output_unit: "percentage", output_decimals: 2,
    data_source: "Reporte de producción / cocina al cierre del turno.",
    capture_example: "Si se descartaron 3 kg de 150 kg producidos, captura Merma=3 y Producción=150. El sistema calcula 2%.",
    input_fields: [
      { key: "merma_kg", label: "Merma (kg)", type: "decimal", unit: "kg", required: true, min: 0, max: null, help_text: "Producto descartado en kg." },
      { key: "produccion_kg", label: "Producción total (kg)", type: "decimal", unit: "kg", required: true, min: 0, max: null, help_text: "Total producido en kg." },
    ],
  },
  {
    key: "tasa_rotacion",
    label: "Tasa de rotación de personal",
    description: "Empleados que salieron en el período respecto a la plantilla promedio.",
    formula_template: "(bajas_mes / plantilla_promedio) * 100",
    formula_human: "(Bajas del período ÷ Plantilla promedio) × 100",
    output_unit: "percentage", output_decimals: 2,
    data_source: "Registro de altas y bajas de RH.",
    capture_example: "Si hubo 2 bajas y la plantilla promedio fue 40, captura Bajas=2 y Plantilla=40. El sistema calcula 5%.",
    input_fields: [
      { key: "bajas_mes", label: "Bajas del período", type: "integer", unit: "unidades", required: true, min: 0, max: null, help_text: "Empleados que salieron en el período." },
      { key: "plantilla_promedio", label: "Plantilla promedio", type: "integer", unit: "unidades", required: true, min: 1, max: null, help_text: "Promedio de empleados activos en el período." },
    ],
  },
  {
    key: "tiempo_espera",
    label: "Tiempo promedio de espera",
    description: "Minutos promedio que un cliente espera para ser atendido.",
    formula_template: "tiempo_total / clientes_atendidos",
    formula_human: "Tiempo total de espera (min) ÷ Clientes atendidos",
    output_unit: "decimal", output_decimals: 1,
    data_source: "Bitácora de atención / caja.",
    capture_example: "Si la suma de esperas fue 120 min entre 60 clientes, captura Tiempo total=120 y Clientes=60. El sistema calcula 2 min.",
    input_fields: [
      { key: "tiempo_total", label: "Tiempo total de espera (min)", type: "decimal", unit: null, required: true, min: 0, max: null, help_text: "Suma de minutos de espera del período." },
      { key: "clientes_atendidos", label: "Clientes atendidos", type: "integer", unit: "unidades", required: true, min: 1, max: null, help_text: "Total de clientes atendidos en el período." },
    ],
  },
];

export const FIELD_TYPES = ["number", "integer", "percentage", "currency", "decimal"];
export const OUTPUT_UNITS = [
  { v: "percentage", l: "Porcentaje (%)" },
  { v: "currency", l: "Moneda (MXN)" },
  { v: "count", l: "Conteo" },
  { v: "decimal", l: "Decimal" },
];

const VAR_RE = /[A-Za-z_][A-Za-z0-9_]*/g;
const RESERVED = new Set(["min", "max", "round", "abs", "sum", "avg", "True", "False", "None", "and", "or", "not"]);

export function extractVars(formula) {
  const found = (formula || "").match(VAR_RE) || [];
  return [...new Set(found.filter((n) => !RESERVED.has(n)))];
}

export function computeLocal(formula, values) {
  try {
    const keys = Object.keys(values);
    const args = keys.map((k) => Number(values[k]));
    if (args.length === 0 || args.some((a) => Number.isNaN(a))) return null;
    const helpers = "const min=Math.min,max=Math.max,abs=Math.abs,round=(x,d=0)=>{const p=Math.pow(10,d);return Math.round(x*p)/p;};";
    // eslint-disable-next-line no-new-func
    const fn = new Function(...keys, `${helpers} return (${formula});`);
    const r = fn(...args);
    return typeof r === "number" && Number.isFinite(r) ? r : null;
  } catch {
    return null;
  }
}
